import GroupDiscussionsPage from 'screens/GroupDiscussionPage';

export default GroupDiscussionsPage;
